import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createMRTColumnHelper } from "material-react-table";

import { partnerCommissionApi } from "../../app/slices/partnerCommissionReport/partnerCommissionSlice";
import CustomTable3 from "../../components/customTable/CustomTable3";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import PdfViewerModels from "./PdfViewerModels";
import axios, { Axios } from "axios";
import Swal from "sweetalert2";
import axiosInstance from "../../utils/axiosInstance";

// Month-year order for reference
const monthYearOrder = [
  "Dec2024",
  "Jan2025",
  "Feb2025",
  "Mar2025",
  "Apr2025",
  "May2025",
  "Jun2025",
  "Jul2025",
  "Aug2025",
  "Sep2025",
  "Oct2025",
  "Nov2025",
  "Dec2025",
  "Jan2026",
  "Feb2026",
  "Mar2026",
  "Apr2026",
  "May2026",
  "Jun2026",
  "Jul2026",
  "Aug2026",
  "Sep2026",
  "Oct2026",
  "Nov2026",
  "Dec2026",
];

export default function PartnerCommission() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const baseUrl = import.meta.env.VITE_BASE_URL;

  const [pdfUrl, setPdfUrl] = useState(null);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState("");

  const [MonthYearPartnerName, setMonthYearPartnerName] = useState({
    month: "",
    year: "",
  });

  const [filteredData, setFilteredData] = useState([]);

  // console.log("filteredData::::::::::::::::::::::::::::", filteredData);
  const [activeColumns, setActiveColumns] = useState(monthYearOrder);

  let rawData = useSelector(
    (state) => state?.partnerCommission?.partnerCommission?.data,
  );

  // console.log("rawData::::::::::::::::::::::::::::::", rawData);

  const loading = useSelector((state) => state.partnerCommission?.loading);

  function getUnpaidNonZeroCommissions(payload) {
    const result = [];

    for (const key in payload) {
      if (key.endsWith("commission") && payload[key] !== 0) {
        const monthPrefix = key.replace("commission", "");
        const paidKey = `${monthPrefix}paid`;

        if (payload[paidKey] === "No") {
          const data = { [key]: payload[key] };
          result.push(data);
        }
      }
    }

    return result;
  }

  // Function to format data based on selected months
  const getFormattedData = (data, visibleMonths = monthYearOrder) => {
    // console.log("nagendra===============>>>", visibleMonths)
    return data?.map((item) => {
      const row = {
        partner_username: item.partner_username ?? "",
        partner_name: item.partner_name ?? "",
        commission_per: item.commission_per ?? "",
        totalPretaxAmountAll: item.totalPretaxAmountAll ?? 0,
        totalCommissionAll: item.totalCommissionAll ?? 0,
        showInvoiceButton: false,
      };

      // Add data for each month in visible months
      visibleMonths.forEach((key) => {
        if (
          item.data?.[`${key}commission`] ||
          item.data?.[`${key}preTaxAmount`] ||
          item.data?.[`${key}paid`] !== undefined
        ) {
          row[`${key}commission`] = item.data?.[`${key}commission`] ?? 0;
          row[`${key}preTaxAmount`] = item.data?.[`${key}preTaxAmount`] ?? 0;
          row[`${key}paid`] = item.data?.[`${key}paid`] === 1 ? "Yes" : "No";
          row.showInvoiceButton = true;
        }
      });

      return row;
    });
  };

  const getNonEmptyMonthKeys = (data, months) => {
    const keys = new Set();

    data?.forEach((item) => {
      months.forEach((month) => {
        const hasData =
          item.data?.[`${month}commission`] ||
          item.data?.[`${month}preTaxAmount`] ||
          item.data?.[`${month}paid`] !== undefined;

        if (hasData) {
          keys.add(month);
        }
      });
    });

    return [...keys];
  };

  useEffect(() => {
    dispatch(partnerCommissionApi(MonthYearPartnerName));
  }, [dispatch, MonthYearPartnerName]);

  useEffect(() => {
    if (Array.isArray(rawData)) {
      setFilteredData(getFormattedData(rawData, monthYearOrder));
      setActiveColumns(monthYearOrder);
    }
  }, [rawData]);

  const columnHelper = createMRTColumnHelper();

  const baseColumns = [
    columnHelper.accessor("partner_username", {
      header: "Username",
      size: 30,
    }),
    columnHelper.accessor("partner_name", {
      header: "Name",
      size: 30,
    }),
    columnHelper.accessor("commission_per", {
      header: "Commission %",
      size: 30,
    }),
    columnHelper.accessor("totalPretaxAmountAll", {
      header: "Total Amount ",
      size: 30,
    }),
    columnHelper.accessor("totalCommissionAll", {
      header: "Total Commission",
      size: 30,
    }),
  ];
  baseColumns.push(
    columnHelper.accessor("2025ViewInvoice", {
      header: "View Invoice",
      size: 30,
      Cell: ({ cell }) => {
        const rowData = cell.row.original;
        console.log("rowdata::::::::::::::::::::::::::::", rowData);

        const handleViewInvoice = async () => {
          try {
            const url = `/generateInvoiceOfPartnerMultipleMonth`;
            // const url = `${baseUrl}/generateInvoiceOfPartnerMultipleMonth`;
            const headers = {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            };
            // console.log(
            //   "rowdata dddddddddddddd::::::::::::::::::::::::::::",
            //   rowData
            // );

            const unpaidComms = getUnpaidNonZeroCommissions(rowData);

            const payload = {
              username: rowData?.partner_username,
              commissions: unpaidComms,
            };
            console.log("name::::::::::::::::::::;;;;;;;;;", payload);
            const response = await axiosInstance.post(url, payload);
            // const response = await axios.post(url, payload, { headers });

            // console.log(
            //   "API Response::fghjhhhhhhhhhhhhhhhhhhhhhhhhhhhhh::::::::::::::",
            //   response.data
            // );

            if (!response.data.error) {
              const pdfUrl = response.data.data.pdfLink;
              setPdfUrl(pdfUrl);
              setOpen(true);
              setData(response?.data?.data);
              // Swal.fire({
              //   title: "Success",
              //   text: response.data.message,
              //   icon: "success",
              //   timer: 3000,
              //   showConfirmButton: false,
              // });
            } else {
              Swal.fire({
                icon: "error",
                title: "Invoice Failed",
                text: response.data.message,
              });
            }
          } catch (error) {
            console.error("Error invoice::::::::::::::::::::::::::::", error);
          }
        };

        if (!rowData?.showInvoiceButton) return null;

        return (
          // const rowData = cell.row.original;
          rowData.totalCommissionAll !== 0 && (
            <Button
              onClick={handleViewInvoice}
              sx={{
                backgroundColor: "#4a2a7d",
                color: "white !important",
              }}
            >
              View Invoice
            </Button>
          )
        );
      },
    }),
    columnHelper.accessor("2025ViewUpdatePayment", {
      header: "Update Payment Status",
      size: 300,
      Cell: ({ cell }) => {
        const rowData = cell.row.original;

        const handleViewInvoice = async () => {
          try {
            const headers = {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            };

            const commissionsArray = getUnpaidNonZeroCommissions(rowData).map(
              (item) => {
                const [key, val] = Object.entries(item)[0];
                return { [key]: Number(val) };
              },
            );

            if (!commissionsArray.length) {
              Swal.fire("Info", "No unpaid commissions found.", "info");
              return;
            }
            const inputFieldsHtml = `
  <div style="padding: 8px;">
    <div style="display: flex; gap: 16px; margin-bottom: 16px;">
      <div style="flex: 1;">
        <label style="font-weight: 600; font-size: 14px; margin-bottom: 4px; display: inline-block;">Payment ID</label>
        <input id="paymentIdInput" type="text" placeholder="Enter Payment ID"
          style="width: 100%; padding: 10px; border-radius: 4px; border: 1px solid #ccc;" />
      </div>
      <div style="flex: 1;">
        <label style="font-weight: 600; font-size: 14px; margin-bottom: 4px; display: inline-block;">Transaction ID</label>
        <input id="transactionIdInput" type="text" placeholder="Enter Transaction ID"
          style="width: 100%; padding: 10px; border-radius: 4px; border: 1px solid #ccc;" />
      </div>
    </div>
  </div>
`;

            // Build checklist UI
            let checkboxHtml = `
          <table style="width:100%; text-align:left; border-collapse: collapse;">
            <thead>
              <tr>
                <th style="padding: 8px;">Select</th>
                <th style="padding: 8px;">Commission Month</th>
                <th style="padding: 8px;">Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
        `;

            commissionsArray.forEach((item, index) => {
              const [key, value] = Object.entries(item)[0];
              checkboxHtml += `
            <tr>
              <td style="padding: 8px;">
                <input type="checkbox" id="chk_${index}" data-key="${key}" checked>
              </td>
              <td style="padding: 8px;">${key}</td>
              <td style="padding: 8px;">₹${value}</td>
            </tr>
          `;
            });

            checkboxHtml += "</tbody></table>";

            const { isConfirmed, value } = await Swal.fire({
              title: "Select Commissions to Update",
              html: `<form id="commissionForm">${inputFieldsHtml}${checkboxHtml}</form>`,
              confirmButtonText: "Update",
              showCancelButton: true,
              preConfirm: () => {
                const paymentId = document
                  .getElementById("paymentIdInput")
                  ?.value?.trim();
                const transactionId = document
                  .getElementById("transactionIdInput")
                  ?.value?.trim();

                if (!paymentId || !transactionId) {
                  Swal.showValidationMessage(
                    "Both Payment ID and Transaction ID are required.",
                  );
                  return;
                }

                const checkboxes = document.querySelectorAll(
                  "#commissionForm input[type='checkbox']",
                );
                const selected = [];
                checkboxes.forEach((chk) => {
                  if (chk.checked) {
                    const key = chk.dataset.key;
                    const value = commissionsArray.find(
                      (obj) => Object.keys(obj)[0] === key,
                    )[key];
                    selected.push({ [key]: value });
                  }
                });

                if (!selected.length) {
                  Swal.showValidationMessage(
                    "Please select at least one commission.",
                  );
                  return;
                }

                return {
                  paymentId,
                  transactionId,
                  selected,
                };
              },
            });

            if (isConfirmed && value?.selected?.length) {
              const { paymentId, transactionId, selected } = value;

              const updatePayload = {
                username: rowData?.partner_username,
                commissions: selected,
                paymentId,
                transactionId,
              };

              const url = `/updateCommissionPaidMultiple`;
              // const url = `${baseUrl}/updateCommissionPaidMultiple`;
              const updateResponse = await axiosInstance.post(
                url,
                updatePayload,
                {
                  // headers,
                },
              );
              // const updateResponse = await axios.post(url, updatePayload, {
              //   headers,
              // });

              // console.log("Update Response:", updateResponse.data);

              if (updateResponse.data?.error) {
                Swal.fire(
                  "Update Failed",
                  updateResponse.data.message,
                  "error",
                );
              } else {
                selected.forEach((item) => {
                  const key = Object.keys(item)[0];
                  rowData[`${key}_status`] = "Yes";
                });

                rowData.showInvoiceButton = false;

                Swal.fire(
                  "Updated",
                  "Commissions updated successfully!",
                  "success",
                );
              }

              dispatch(partnerCommissionApi(MonthYearPartnerName));
            }
          } catch (error) {
            console.error("Error in commission update flow:", error);
            Swal.fire("Error", "Something went wrong. Try again.", "error");
          }
        };

        if (!rowData?.showInvoiceButton) return null;

        return (
          <Button
            onClick={handleViewInvoice}
            sx={{
              backgroundColor: "#4a2a7d",
              color: "white !important",
            }}
          >
            Update Payment Status
          </Button>
        );
      },
    }),
  );

  // Function to generate month columns dynamically, only if data exists
  const generateMonthColumns = (keys) =>
    keys.flatMap((key) => {
      // Convert "Dec2024" to "Dec 2024"
      const monthHeader = `${key.slice(0, 3)} ${key.slice(3)}`;

      // Check if data exists for this month and only add columns if data is present
      return [
        itemHasData(key) &&
          columnHelper.accessor(`${key}commission`, {
            header: `${monthHeader} Commission`,
            size: 30,
          }),
        itemHasData(key) &&
          columnHelper.accessor(`${key}preTaxAmount`, {
            header: `${monthHeader} Pre-Tax`,
            size: 30,
          }),
        itemHasData(key) &&
          columnHelper.accessor(`${key}paid`, {
            header: `${monthHeader} Paid`,
            size: 30,
          }),
      ].filter(Boolean); // Remove null columns (if any)
    });

  const itemHasData = (monthKey) => {
    if (!Array.isArray(rawData)) return false;
    return rawData.some(
      (item) =>
        item?.data?.[`${monthKey}commission`] ||
        item?.data?.[`${monthKey}preTaxAmount`] ||
        item?.data?.[`${monthKey}paid`] !== undefined,
    );
  };

  const monthColumns = generateMonthColumns(activeColumns);

  // console.log("clmsssssssssssssss", monthColumns);

  const columns = [...baseColumns, ...monthColumns];

  // console.log("culumnsssssssssssssssssssss", columns);

  // Handle month/year change and filter columns
  const handleMonthYearChange = (value) => {
    const selectedKey = `${value.month}${value.year}`;
    setMonthYearPartnerName(value);

    const startIndex = monthYearOrder.indexOf(selectedKey);

    if (startIndex !== -1) {
      const futureMonths = monthYearOrder.slice(startIndex);
      const visibleMonths = getNonEmptyMonthKeys(rawData, futureMonths);

      setActiveColumns(visibleMonths);
      setFilteredData(getFormattedData(rawData, visibleMonths));
    } else {
      // Reset to all if invalid
      setActiveColumns(monthYearOrder);
      setFilteredData(getFormattedData(rawData, monthYearOrder));
    }
  };

  return (
    <>
      {/*  */}

      <CustomTable3
        columns={columns}
        data={filteredData} // finally response mil jyega aur list data show hoga.
        showMonthYearsPicker={true}
        onMonthYearChange={handleMonthYearChange}
        loading={loading}
        // Add a prop for sticky headers
        tableProps={{
          style: { overflowY: "auto" }, // Add auto-scroll for the table
        }}
        permissionKey="partnerCommisssionReport"
      />

      <style>
        {`
          .MuiTableCell-head {
            position: sticky;
            top: 0;
            background-color: white;
            z-index: 10;
          }
        `}
      </style>

      <PdfViewerModels
        pdfUrl={pdfUrl}
        open={open}
        onClose={() => setOpen(false)}
        data={data}
      />
    </>
  );
}
